// ─────────────────────────────────────────────
//  tutorialSlides.js — Contenido del tutorial (historias)
//  Reemplaza image con tus PNG en public/tutorial/
// ─────────────────────────────────────────────

export const TUTORIAL_SLIDES = [
	{
		id: 'propina',
		icon: '💸',
		accent: '#0cbdb1',
		title: 'Propina',
		subtitle: 'Divide la cuenta al instante',
		body: 'Ingresa el consumo, elige el porcentaje de propina o utiliza el slider para ajustarlo. Puedes divir entre varios y ver el desglose por persona. Puedes redondear el total o desactivarlo para ver los centavos.',
		image: '/tutorial/propina.svg',
	},
	{
		id: 'porcentaje',
		icon: '🏷️',
		accent: '#f08400',
		title: 'Porcentaje',
		subtitle: 'Descuentos y recargos',
		body: 'Calcula cuánto es un descuento o un aumento sobre cualquier monto. Cambia entre descontar o agregar y ajusta el porcentaje con el slider ó da click en la cantidad y utiliza el teclado para ingresar el porcentaje.',
		image: '/tutorial/porcentaje.svg',
	},
	{
		id: 'comparar',
		icon: '↔️',
		accent: '#30D158',
		title: 'Comparar',
		subtitle: '¿Cuál conviene más?',
		body: '¿Vas al super y quieres comparar varios productos?Compara hasta 3 productos por precio por unidad (ml, g, kg, piezas…). La app te muestra el ganador, el ahorro y equivalencias entre opciones.',
		image: '/tutorial/comparar.svg',
	},
	{
		id: 'peso',
		icon: '⚖️',
		accent: '#dc0184',
		title: 'Peso',
		subtitle: 'Presupuesto ↔ peso',
		body: 'Define una referencia (precio por porción) y mueve presupuesto o peso: los sliders están sincronizados. Como cuando vas a una carnicería, cremería, incluso en el tianguis ó comprando barbacoa y no sabes cuánto te deben dar o cuánto pagarás.',
		image: '/tutorial/peso.svg',
	},
	{
		id: 'inversion',
		icon: '📈',
		accent: '#007AFF',
		title: 'Inversión',
		subtitle: 'Proyecta tu rendimiento',
		body: 'Simula interés simple o compuesto, plazo en días o meses, y opcionalmente comisión e ISR. Incluye tabla de crecimiento mes a mes.',
		image: '/tutorial/inversion.svg',
	},
	{
		id: 'gracias',
		icon: '🙌',
		accent: '#8e8e93',
		title: '¡Gracias por usar AR Cuánto!',
		subtitle: 'Tu opinión nos motiva',
		body: 'Esperamos que estas calculadoras te sean útiles en el día a día. Si tienes ideas, mejoras o nuevas secciones que te gustaría ver, ¡cuéntanos! ó comparte la app con tus amigos y familiares.',
		image: '/tutorial/gracias.svg',
		isFinal: true,
	},
];

export const SLIDE_DURATION_MS = 20000;
